var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trial global-page-base-layout" },
    [
      _c("div", { staticClass: "select-conditions" }, [
        _c(
          "div",
          { staticClass: "select-conditions-row" },
          [
            _c("el-col", { attrs: { span: 8 } }, [
              _c(
                "div",
                { staticClass: "grid-content bg-purple" },
                [
                  _vm._v("\n          标题：\n          "),
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { placeholder: "标题" },
                    model: {
                      value: _vm.titlevalue,
                      callback: function ($$v) {
                        _vm.titlevalue = $$v
                      },
                      expression: "titlevalue",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("el-col", { attrs: { span: 8 } }, [
              _c(
                "div",
                { staticClass: "grid-content bg-purple-light" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "medium" },
                      on: { click: _vm.handleFilter },
                    },
                    [_vm._v("筛选")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "clear-all",
                      on: { click: _vm.clearAllConditon },
                    },
                    [_vm._v("清空筛选条件")]
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "add-btn" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleCreate } },
            [_vm._v("添加会议通道")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "tooltip-effect": "dark",
                height: "calc(100vh - 360px)",
                "header-cell-style": { background: _vm.tableHeaderColor },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "title", label: "标题" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "address", label: "地址" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "updateTime", label: "更新时间" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { fixed: "right", label: "操作", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.handleUpdate(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-sizes": _vm.pageSizes,
                  "page-size": 10,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "channel-dialog",
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            top: "10vh",
            "close-on-click-modal": false,
            width: "45%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-content" }, [
            _c(
              "div",
              { staticClass: "form-section" },
              [
                _c("div", { staticClass: "section-title" }, [
                  _c("i", { staticClass: "el-icon-video-camera" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("会议通道信息")]),
                ]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      model: _vm.form,
                      "label-position": "left",
                      "label-width": "110px",
                      rules: _vm.formRules,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "标题", prop: "title" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "text",
                            placeholder: "请输入会议通道标题",
                            maxlength: "50",
                            "show-word-limit": "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.title,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "title", $$v)
                            },
                            expression: "form.title",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "地址", prop: "address" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "text",
                            placeholder: "请输入会议通道地址",
                            maxlength: "200",
                            "show-word-limit": "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.address,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "address", $$v)
                            },
                            expression: "form.address",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-check" },
                  on: {
                    click: function ($event) {
                      return _vm.handleSubmit("form")
                    },
                  },
                },
                [_vm._v("\n        确 定\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }